<template>
  <div class="scs-icon-bar">
    <div
      v-for="(icon, index) in icons"
      :key="index"
      :class="
        icon === 'trash-can' ? 'icon-background trash-can' : 'icon-background'
      "
      @click="iconClicked(icon)"
    >
      <svg
        v-if="icon === 'reset-password'"
        width="32"
        height="33"
        viewBox="0 0 32 33"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16 31.642C24.2843 31.642 31 24.9263 31 16.642C31 8.35776 24.2843 1.64203 16 1.64203C7.71573 1.64203 1 8.35776 1 16.642C1 24.9263 7.71573 31.642 16 31.642Z"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M18.0938 17.3608C18.9475 16.8955 19.6219 16.159 20.0104 15.2678C20.399 14.3765 20.4796 13.3812 20.2395 12.439C19.9994 11.4968 19.4523 10.6614 18.6846 10.0648C17.9169 9.4682 16.9723 9.14432 16 9.14432C15.0277 9.14432 14.0831 9.4682 13.3154 10.0648C12.5477 10.6614 12.0006 11.4968 11.7605 12.439C11.5204 13.3812 11.601 14.3765 11.9896 15.2678C12.3781 16.159 13.0525 16.8955 13.9063 17.3608L11.75 22.392C11.6671 22.5819 11.6328 22.7893 11.65 22.9957C11.6671 23.2022 11.7353 23.4011 11.8484 23.5746C11.9615 23.7481 12.116 23.8908 12.2979 23.9899C12.4798 24.0889 12.6835 24.1412 12.8906 24.142H19.1094C19.3165 24.1412 19.5202 24.0889 19.7021 23.9899C19.884 23.8908 20.0385 23.7481 20.1516 23.5746C20.2647 23.4011 20.3329 23.2022 20.3501 22.9957C20.3672 22.7893 20.3329 22.5819 20.25 22.392L18.0938 17.3608Z"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <svg
        v-if="icon === 'automation'"
        width="35"
        height="33"
        viewBox="0 0 35 33"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.5 22.1855C20.1127 22.1855 22.2308 20.0582 22.2308 17.434C22.2308 14.8099 20.1127 12.6826 17.5 12.6826C14.8873 12.6826 12.7692 14.8099 12.7692 17.434C12.7692 20.0582 14.8873 22.1855 17.5 22.1855Z"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M24.3399 12.7519C24.5772 13.0931 24.7849 13.454 24.9608 13.8308L27.5135 15.2563C27.8322 16.6901 27.8356 18.1765 27.5233 19.6118L24.9608 21.0372C24.7849 21.414 24.5772 21.775 24.3399 22.1162L24.3892 25.0561C23.3074 26.0462 22.027 26.7922 20.6341 27.2438L18.1209 25.7292C17.7075 25.7589 17.2925 25.7589 16.8791 25.7292L14.3757 27.2339C12.9785 26.7905 11.6939 26.0474 10.6108 25.0561L10.6601 22.1261C10.4248 21.7802 10.2172 21.4161 10.0392 21.0372L7.48654 19.6118C7.1678 18.1779 7.16444 16.6915 7.47668 15.2563L10.0392 13.8308C10.2151 13.454 10.4228 13.0931 10.6601 12.7519L10.6108 9.81191C11.6926 8.82179 12.973 8.07585 14.3659 7.62427L16.8791 9.13879C17.2925 9.10909 17.7075 9.10909 18.1209 9.13879L20.6243 7.63417C22.0215 8.07753 23.3061 8.8206 24.3892 9.81191L24.3399 12.7519Z"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M28.5385 11.1643H33.4996V5.95135"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M2.125 16.9391C2.12388 13.8841 3.02499 10.8974 4.71434 8.35691C6.40369 5.8164 8.80536 3.83626 11.6155 2.667C14.4256 1.49775 17.5179 1.19193 20.5011 1.78825C23.4843 2.38456 26.2244 3.85621 28.3746 6.01699L33.4996 11.1644"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6.46155 22.1198H1.50042V27.3328"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M32.875 16.345C32.8761 19.4 31.975 22.3867 30.2857 24.9272C28.5963 27.4677 26.1946 29.4479 23.3845 30.6171C20.5744 31.7864 17.4821 32.0922 14.4989 31.4959C11.5157 30.8996 8.77565 29.4279 6.62539 27.2671L1.50039 22.1197"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <svg
        v-if="icon === 'contract'"
        width="32"
        height="29"
        viewBox="0 0 32 29"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1 27.9543V2.84506C1 2.51209 1.1317 2.19276 1.36612 1.95732C1.60054 1.72187 1.91848 1.5896 2.25 1.5896H29.75C30.0815 1.5896 30.3995 1.72187 30.6339 1.95732C30.8683 2.19276 31 2.51209 31 2.84506V27.9543L26 25.4434L21 27.9543L16 25.4434L11 27.9543L6 25.4434L1 27.9543Z"
          stroke="var(--contrastColor)"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M18.5 11.6333H26"
          stroke="var(--contrastColor)"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M18.5 16.6552H26"
          stroke="var(--contrastColor)"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6.03125 13.1273C6.03125 13.1273 7.40625 11.1938 9.46875 11.1938C13.9375 11.1938 13.5938 18.0989 9.46875 18.0989C6.71875 18.0989 6.71875 13.9559 10.8438 13.9559C13.5938 13.9559 15.3125 16.0274 15.3125 16.0274"
          stroke="var(--contrastColor)"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <svg
        v-if="icon === 'forms'"
        width="33"
        height="26"
        viewBox="0 0 33 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.01611 1.86884H31.1125V23.2803C31.1125 23.6143 30.9804 23.9347 30.7452 24.1709C30.51 24.4071 30.191 24.5398 29.8585 24.5398H2.27013C1.93754 24.5398 1.61858 24.4071 1.38341 24.1709C1.14823 23.9347 1.01611 23.6143 1.01611 23.2803V1.86884Z"
          stroke="var(--contrastColor)"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1.01611 9.42584H31.1125"
          stroke="var(--contrastColor)"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1.01611 16.9828H31.1125"
          stroke="var(--contrastColor)"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.79395 9.42584V24.5398"
          stroke="var(--contrastColor)"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <svg
        v-if="icon === 'invoice'"
        width="32"
        height="29"
        viewBox="0 0 32 29"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1 27.9543V2.84506C1 2.51209 1.1317 2.19276 1.36612 1.95732C1.60054 1.72187 1.91848 1.5896 2.25 1.5896H29.75C30.0815 1.5896 30.3995 1.72187 30.6339 1.95732C30.8683 2.19276 31 2.51209 31 2.84506V27.9543L26 25.4434L21 27.9543L16 25.4434L11 27.9543L6 25.4434L1 27.9543Z"
          stroke="var(--contrastColor)"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M18.5 11.6333H26"
          stroke="var(--contrastColor)"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M18.5 16.6552H26"
          stroke="var(--contrastColor)"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.54199 9.40216V19.6028"
          stroke="var(--contrastColor)"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12.2764 12.5407C12.2764 12.2831 12.2258 12.028 12.1277 11.79C12.0295 11.552 11.8857 11.3358 11.7043 11.1536C11.5229 10.9714 11.3076 10.8269 11.0707 10.7284C10.8337 10.6298 10.5797 10.579 10.3232 10.579H8.56543C8.04743 10.579 7.55064 10.7857 7.18436 11.1536C6.81808 11.5215 6.6123 12.0204 6.6123 12.5407C6.6123 13.061 6.81808 13.5599 7.18436 13.9278C7.55064 14.2957 8.04743 14.5024 8.56543 14.5024H10.7139C11.2319 14.5024 11.7287 14.709 12.0949 15.0769C12.4612 15.4448 12.667 15.9438 12.667 16.464C12.667 16.9843 12.4612 17.4832 12.0949 17.8511C11.7287 18.219 11.2319 18.4257 10.7139 18.4257H8.37012C7.85212 18.4257 7.35533 18.219 6.98905 17.8511C6.62277 17.4832 6.41699 16.9843 6.41699 16.464"
          stroke="var(--contrastColor)"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <svg
        v-if="icon === 'credit-card'"
        width="28"
        height="21"
        viewBox="0 0 28 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M26 1.10486H2C1.44772 1.10486 1 1.55453 1 2.10923V18.1792C1 18.7339 1.44772 19.1835 2 19.1835H26C26.5523 19.1835 27 18.7339 27 18.1792V2.10923C27 1.55453 26.5523 1.10486 26 1.10486Z"
          stroke="var(--contrastColor)"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M19 15.1661H23"
          stroke="var(--contrastColor)"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M13 15.1661H15"
          stroke="var(--contrastColor)"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1 6.23981H27"
          stroke="var(--contrastColor)"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <svg
        v-if="icon === 'email'"
        width="32"
        height="25"
        viewBox="0 0 32 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M31 1.39203L16 15.142L1 1.39203"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1 1.39203H31V22.642C31 22.9735 30.8683 23.2915 30.6339 23.5259C30.3995 23.7603 30.0815 23.892 29.75 23.892H2.25C1.91848 23.892 1.60054 23.7603 1.36612 23.5259C1.1317 23.2915 1 22.9735 1 22.642V1.39203Z"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M13.2656 12.642L1.39062 23.5327"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M30.6094 23.5327L18.7344 12.642"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <svg
        v-if="icon === 'edit'"
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.58751 23.9843H2.00001C1.73479 23.9843 1.48044 23.8785 1.2929 23.6901C1.10536 23.5018 1.00001 23.2463 1.00001 22.9799V17.368C0.999551 17.2376 1.02471 17.1084 1.07404 16.9877C1.12338 16.8671 1.19591 16.7574 1.28751 16.665L16.2875 1.59941C16.3806 1.50451 16.4915 1.42915 16.6138 1.37771C16.7361 1.32627 16.8674 1.29977 17 1.29977C17.1326 1.29977 17.2639 1.32627 17.3862 1.37771C17.5085 1.42915 17.6195 1.50451 17.7125 1.59941L23.2875 7.19877C23.382 7.29223 23.457 7.40362 23.5082 7.52648C23.5595 7.64933 23.5858 7.78119 23.5858 7.91438C23.5858 8.04757 23.5595 8.17943 23.5082 8.30229C23.457 8.42514 23.382 8.53654 23.2875 8.63L8.28751 23.6955C8.19546 23.7875 8.08625 23.8604 7.96614 23.9099C7.84602 23.9595 7.71736 23.9848 7.58751 23.9843V23.9843Z"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M13 4.90125L20 11.9318"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <svg
        v-if="icon === 'trash-can'"
        width="25"
        height="27"
        viewBox="0 0 25 27"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M23.1764 5.10919H1.17639"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.17639 11.1354V19.1704"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M15.1764 11.1354V19.1704"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M21.1764 5.10919V24.1922C21.1764 24.4586 21.071 24.7141 20.8835 24.9024C20.696 25.0908 20.4416 25.1966 20.1764 25.1966H4.17639C3.91118 25.1966 3.65682 25.0908 3.46929 24.9024C3.28175 24.7141 3.17639 24.4586 3.17639 24.1922V5.10919"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M17.1764 5.10922V3.10048C17.1764 2.56773 16.9657 2.05679 16.5906 1.68008C16.2155 1.30337 15.7068 1.09174 15.1764 1.09174H9.17639C8.64596 1.09174 8.13725 1.30337 7.76218 1.68008C7.38711 2.05679 7.17639 2.56773 7.17639 3.10048V5.10922"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    checkContains(icon) {
      return this.icons.includes(icon);
    },
    iconClicked(icon) {
      this.$emit("icon-clicked", icon);
    },
  },
  created() {},
  components: {},
  emits: ["icon-clicked"],
  props: ["icons"],
};
</script>
<style scoped>
.scs-icon-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 40px;
  background-color: var(--secondaryColor);
  border-radius: 25px;
}

svg {
  max-height: 50%;
  max-width: 50%;
}

.icon-background {
  height: 40px;
  width: 40px;
  margin: 0 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.icon-background:hover {
  filter: drop-shadow(0px 0px 2px var(--shadow));
}
.trash-can {
  border-radius: 35px;
  background-color: #ff8a87;
  margin-right: 0;
}

.trash-can:hover {
  filter: drop-shadow(0px 0px 2px var(--shadow));
}
</style>
